import { render, staticRenderFns } from "./WorkTextArea.vue?vue&type=template&id=422b8d6b"
import script from "./WorkTextArea.vue?vue&type=script&lang=js"
export * from "./WorkTextArea.vue?vue&type=script&lang=js"
import style0 from "./WorkTextArea.vue?vue&type=style&index=0&id=422b8d6b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports